const config = {
    API_GATEWAY: {
      BASE_URL: 'https://admin-dev.mp.directsale.vn',
    },
  };
  export default config;
  